export const DEFAULT_ITEMS_PER_PAGE_OPTIONS = [10, 25, 50, 100] as const;
export const DEFAULT_ITEMS_PER_PAGE = 25;

export type Pagination = {
  offset: number;
  limit: number;
}

export type Paginator = {
  pageNumber: number
  pageCount?: number
  itemsPerPage: number
  totalItemCount?: number
  infinite?: boolean
  itemsPerPageOptions?: number[];

  onGoBack?: () => void
  onGoNext?: () => void
  onSelectPage?: (index: number) => void
  onPageChange?: () => void | Promise<void>;
  onItemsPerPageChange?: (limit: number) => void;
}


export type PaginatedResult<T = any> = {
  count: number;
  entries: T[];
}
